export const onlyNumber = (p) => {
  // eslint-disable-next-line prefer-regex-literals
  const regex = new RegExp(/^[0-9]+$/);
  return regex.test(p);
};
